export const REFUSE_EMERGENCY_ORDERS_MODAL = "REFUSE_EMERGENCY_ORDERS_MODAL";
export const APPROVE_EMERGENCY_ORDERS_MODAL = "APPROVE_EMERGENCY_ORDERS_MODAL";
